import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ListModeType } from '@src/app/modules/list-mode-switcher';
import { TuiSizeS } from '@taiga-ui/core';
import { BaseResizableComponent } from '@src/app/modules/base';

import { LoyaltyProgramCategoryList } from '../../models';
import { CategoriesStoreKeys, LoyaltyProgramFilterService, LpCategoriesStoreService } from '../../services';
import { LoyaltyProgramFilterData } from '../../types';

@Component({
  selector: 'lp-products-list-category',
  templateUrl: './products-list-category.component.html',
  styleUrls: ['./products-list-category.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductsListCategoryComponent extends BaseResizableComponent {
  private readonly loyaltyProgramFilterService = inject(LoyaltyProgramFilterService);
  private readonly lpCategoriesStore = inject(LpCategoriesStoreService);

  @Input() categories?: LoyaltyProgramCategoryList[] | null = null;

  @Input() productListMode: ListModeType = 'grid';
  @Input() showIsFavorite: boolean = false;

  @Input() size: TuiSizeS = 'm';

  @Output() applyFilterAndChangeRoute = new EventEmitter<LoyaltyProgramFilterData>();

  override ngOnInit(): void {
    super.ngOnInit();

    this.loyaltyProgramFilterService.getCategories(true);
  }

  selectCategory(categoryId?: string) {
    const subcategories = this.lpCategoriesStore
      .getData(CategoriesStoreKeys.InUse)
      ?.find(category => category.id === categoryId)?.items;

    this.applyFilterAndChangeRoute.emit({
      categories: subcategories,
    });
  }
}
